import { ProviderGroup } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import { VerifyShipResponse } from '~/lib/api/smartsend/types';
import useOnLoad from '~/routes/use-on-load';
import { useState } from 'react';
import ProviderGroupSummaryTotalFallback from './ProviderGroupSummaryTotalFallback';
import ProviderGroupSummaryTotalVerified from './ProviderGroupSummaryTotalVerified';
import { SettingsCache } from '~/lib/consts/settings-cache';
import Loading from '~/components/loading/Loading';

interface props {
  group: ProviderGroup;
  verifyShip: (group: ProviderGroup) => Promise<VerifyShipResponse>;
}

const ProviderGroupSummaryTotal: React.FC<props> = (props) => {
  const [loading, setLoading] = useState(SettingsCache.settings.Features.includes('PreBookingVerification'));
  const [breakdown, setBreakdown] = useState<Record<string, number> | null>(null);

  useOnLoad(() => {
    const onLoad = async () => {
      try {
        const res = await props.verifyShip(props.group);
        setBreakdown(res.Breakdown);
      } catch {
        // No need to do anything, we'll just show the fallback breakdown
      } finally {
        setLoading(false);
      }
    };
    if (SettingsCache.settings.Features.includes('PreBookingVerification')) {
      onLoad();
    }
  });

  if (loading) {
    return <Loading />;
  }

  const verifiedBreakdown = props.group.Discount?.Breakdown ?? breakdown;

  if (verifiedBreakdown) {
    return <ProviderGroupSummaryTotalVerified breakdown={verifiedBreakdown} currencyCode={props.group.CurrencyCode} />;
  }

  return <ProviderGroupSummaryTotalFallback group={props.group} />;
};

export default ProviderGroupSummaryTotal;
